import { type IRow, type ITableColumn, VisibleType } from "@comet/admin";
import saveAs from "file-saver";

import { isVisible } from "./isVisible";
import { safeColumnGet } from "./safeColumnGet";

export const loadLimit = 20;

export interface ExportVariables {
    page: number;
    size: number;
}

export async function generateCSVExport<TRow extends IRow>(columns: Array<ITableColumn<TRow>>, data: TRow[], fileName: string) {
    const csvColumns: string[] = [];
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const csvRows: any[] = [];

    columns.forEach((column) => {
        const header = column.headerExcel != null ? column.headerExcel : safeStringFromReactNode(column.header);

        if (isVisible(VisibleType.Export, column.visible)) {
            csvColumns.push(header);
        }
    });

    const headerRow = csvColumns.join(";");

    data.map((row) => {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const rowValues: any[] = [];
        columns.forEach((column) => {
            if (isVisible(VisibleType.Export, column.visible)) {
                if (column.renderExcel) {
                    rowValues.push(column.renderExcel(row));
                } else {
                    const render = column.render != null ? safeStringFromReactNode(column.render(row)) : null;
                    rowValues.push(render != null ? render : safeColumnGet(row, column.name));
                }
            }
        });
        csvRows.push(rowValues);
    });

    const dataRows = csvRows.map((row) => row.join(";"));

    const fileContent = [headerRow, ...dataRows].join("\n");

    const blob = new Blob(["\uFEFF", fileContent], { type: "text/csv;charset=utf-8" });

    saveAs(blob, `${fileName}.csv`);
}

function safeStringFromReactNode(node: string | React.ReactNode): string {
    return typeof node === "string" ? node : typeof node === "number" ? String(node) : "";
}
